module.exports = __webpack_public_path__ + "9ccd1a93ffec5a0ed688fe8779f3c9a4.woff2";